export const MAKE_REQUEST='ORGANIZATION_MAKE_REQUEST'
export const FAIL_REQUEST='FAIL_REQUEST'
export const ORGANIZATIONS_LIST = "ORGANIZATIONS_LIST";